var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{staticClass:"ma-0 ma-md-2"},[_c('v-col',{attrs:{"rows":"12"}},[_c('edit-user-box')],1)],1),_c('v-row',{staticClass:"ma-0 ma-md-2"},[_c('v-col',{attrs:{"rows":"12"}},[_c('access-tokens-box',{attrs:{"user_guid":_vm.guid}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }